<template>
	<div style="width:100%;heigh:100%;">
		<div class="table_searchbar">
			<el-row :gutter="W?20:0">
				<el-col :span="span">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">设备编号：</span>
						<el-input class='target' style="width:180px" size="small" v-model="searchForm.deviceCode" maxlength="16" placeholder="设备编号"></el-input>
					</div>
				</el-col>
				<el-col :span="span">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警等级：</span>
						<el-select style="max-width:180px" size="small" v-model="searchForm.level" maxlength="16" placeholder="请选择">
							<el-option label="高" value=1></el-option>
							<el-option label="中" value=2></el-option>
							<el-option label="低" value=3></el-option>
						</el-select>
					</div>
				</el-col>
				<el-col :span="W?span:6">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警类型：</span>
						<el-select style="max-width:180px" size="small" v-model="searchForm.alarmType" maxlength="16" placeholder="请选择">
							<el-option label="业务告警" :value="3"/>
							<el-option label="设备故障" :value="2"/>
							<el-option label="通信故障" :value="1"/>
						</el-select>
					</div>
				</el-col>
			</el-row>
			<el-row :gutter="W?20:0">
				<el-col :span="span">
					<div class="" @keydown.enter="btnSearch()">
						<span class="title">告警名称：</span>
						<el-input class='target' style="width:180px" size="small" v-model="searchForm.alarmRuleName" maxlength="16"	placeholder="告警名称"></el-input>
					</div>
				</el-col>
				<el-col :span="W?10:13">
					<div class="">
						<span class="title">告警时间：</span>
						<el-date-picker style="width:214px" size="small" class="dataRange y_inputWidth" v-model="searchForm.date" type="daterange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
					</div>
				</el-col>
				<el-col :span="W?(24-3*span):4">
					<div style="text-align:right">
						<el-button size='mini' type="primary" icon="el-icon-search" @click="btnSearch()">查询</el-button>
						<el-button size='mini' icon="el-icon-refresh" @click='clearSearch'>重置</el-button>
					</div>
				</el-col>
			</el-row>
		</div>

		<!-- 查看窗口开始 -->
		<el-dialog class="view_dialog" title="查看详情" width="600px" :visible.sync="viewDialogVisible" center>
			<el-row type="flex">
				<el-col :span="5">告警名称：</el-col>
				<el-col :span="7">{{currentRow.alarmRuleName}}</el-col>
				<el-col :span="5">设备编号：</el-col>
				<el-col :span="7">{{currentRow.deviceCode}}</el-col>
			</el-row>
			<el-row>
				<el-col :span="5">告警时间：</el-col>
				<el-col :span="7">{{parseDate(currentRow.alarmTime)}}</el-col>
				<el-col :span="5">解除时间：</el-col>
				<el-col :span="7">{{parseDate(currentRow.relieveTime)}}</el-col>
			</el-row>
			<el-row>
				<el-col :span="5">告警类型：</el-col>
				<el-col :span="7">{{ruleType.get(currentRow.alarmType)}}</el-col>
				<el-col :span="5">告警状态：</el-col>
				<el-col :span="7">{{status.get(currentRow.alarmStatus)}}</el-col>
			</el-row>
			<el-row></el-row>
			<span slot="footer" class="dialog-footer" style="margin-top:50px; margin-bottom:30px;">
					<el-button type="primary" @click="viewDialogVisible = false">确 定</el-button>
			</span>
		</el-dialog>

		<el-table :data="tableData" stripe style="width: 100%" class="y_Public_table">
			<el-table-column prop="deviceCode" label="设备编号">
				<template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="scope.row.deviceCode" placement="top">
						<div class="y_clamp">
							<div>{{scope.row.deviceCode}}</div>
						</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="alarmStatus" label="告警状态" :formatter="row=>{return status.get(row.alarmStatus)}"></el-table-column>
			<el-table-column prop="alarmRuleName" label="告警名称">
				<template slot-scope="scope">
					<el-tooltip class="item" effect="dark" :content="scope.row.alarmRuleName" placement="top-start">
						<div class="y_clamp">
							<div>{{scope.row.alarmRuleName}}</div>
						</div>
					</el-tooltip>
				</template>
			</el-table-column>
			<el-table-column prop="alarmType" label="告警类型" :formatter="row=>{return ruleType.get(row.alarmType)}"></el-table-column>
			<el-table-column prop="level" label="告警级别" :formatter="row=>{return level.get(row.level)}"></el-table-column>
			<el-table-column prop="alarmTime" label="告警时间" :formatter='(row)=>parseDate(row.alarmTime)'></el-table-column>
			<el-table-column prop="relieveTime" label="解除时间" :formatter='(row)=>parseDate(row.relieveTime)'></el-table-column>
			<el-table-column label="操作" fixed="right">
				<template slot-scope="scope">
					<el-button @click="viewAlarm(scope.row)" type="text" size="small" v-if="permission.btn_alarmHistory_get">查看</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="page" v-if="tableData.length > 0">
			<div class="total_page"><span> 共{{tableTotalPage}}条 10条/页</span></div>
			<div style="margin-top:10px;text-align:right; margin-bottom:20px;">
				<el-pagination background layout="prev, pager, next" :total="tableTotalPage" @current-change="pageChange" :current-page="tableCurrentPage"></el-pagination>
			</div>
		</div>
	</div>
</template>

<script>
	import axios from "axios";
	import {resolve, reject} from 'q';
	export default {
		name: "dtumgt",
		data: () => {
			return {
				DmouserShow:null,
				TmouserShow:null,
				W: false,
				fristLoad: false,
				remoteLoading: false,
				viewDialogVisible: false,
				btnPressType: 0,//按钮类型： 0-默认 1-查询 2-重置 3-分页
				searchFormTemp: '',//临时搜索数据
				searchForm: {
					deviceCode: '',
					alarmType: '',
					level: '',
					alarmRuleName: '',
					data: '',
				},
				restaurants: [],
				tableData: [],
				status: new Map([[0, '待执行'], [1, '执行中'], [2, '已执行']]),
				level: new Map([[1, '高'], [2, '中'], [3, '低']]),
				ruleType: new Map([[1, '通信故障'], [2, '设备故障'], [3, '业务告警']]),
				currentRow: {},
				tableTotalPage: 100,
				tableCurrentPage: 1,
				permission: JSON.parse(localStorage.getItem("permission")),
			}
		},
		mounted: function () {
			this.initTable();
			this.getAlarmNameRemote('');
			let w = document.documentElement.clientWidth || document.body.clientWidth;
			w >= 1900 ? this.W = true : this.W = false
			window.onresize = () => {
				let w = document.documentElement.clientWidth || document.body.clientWidth;
				w >= 1900 ? this.W = true : this.W = false
			}
		},
		computed: {
			span() {
				return this.W ? 5 : 7
			}
		},
		methods: {
			DmouseOver(ev) {
				console.log(ev)
				let offsetHeight = this.$refs.Dmover.offsetHeight
				let scrollHeight = this.$refs.Dmover.scrollHeight
				if(offsetHeight<scrollHeight){
					this.DmouserShow = ev
				}
				console.log(offsetHeight)
				console.log(scrollHeight)
			},
			Donmouseout() {
				this.DmouserShow = null
			},
			TmouseOver(ev) {
				console.log(ev)
				let offsetHeight = this.$refs.Tmover.offsetHeight
				let scrollHeight = this.$refs.Tmover.scrollHeight
				if(offsetHeight<scrollHeight){
					this.TmouserShow = ev
				}
				console.log(offsetHeight)
				console.log(scrollHeight)
			},
			Tonmouseout() {
				this.TmouserShow = null
			},
			getAlarmNameRemote(name) {
				this.restaurants = [];
				this.remoteLoading = true;
				this.$RequestUtil.get({
					url: '/api/select/getAlarmRules',
					type: 'sync',
					params: {
						name: name
					},
					success: (data) => {
						if (data.code == 0) {
							this.restaurants = data.data;
						} else {
							this.$message({
								type: 'error',
								message: data.message || data.msg
							});
						}
						this.remoteLoading = false;
					}
				});
			},

			search: function () {
				let temp;
				switch (this.btnPressType) {
					case 1:
						temp = commonUtils.cloneObj(this.searchForm);
						this.searchFormTemp = commonUtils.cloneObj(temp);
						break;
					case 0:
						temp = {
						status: '',
						imei: '',
						};
						break;
					case 2:
						temp = this.searchFormTemp
						break;
					case 3:
						temp = this.searchFormTemp;
						break;
				}
				this.$RequestUtil.get({
					url: '/api/alarmHistory/listHistory',
					type: 'sync',
					params: {
						pageNum: this.tableCurrentPage,
						pageSize: 10,
						deviceCode: temp.deviceCode,
						level: temp.level,
						alarmType: temp.alarmType,
						alarmRuleName: temp.alarmRuleName,
						startDate: temp.date ? temp.date[0] : "",
						endDate: temp.date ? temp.date[1] : "",
					},
					success: (res) => {
						if (res.msg == this.$Global.RESPONSE.SUCCESS) {
							this.tableData = res.data;
							this.tableTotalPage = res.totalPages;
							if (res.totalPages == 0 && this.fristLoad) {
								this.$message.warning('查询不到符合条件的数据');
							}
							this.fristLoad = true
						} else {
							this.$message.error(res.message || res.msg)
						}

					}
				});
			},

			pageChange: function (targetPage) {
				this.tableCurrentPage = targetPage;
				this.btnPressType = 3;
				this.search();
			},

			initTable: function () {
				this.search();
			},

			btnSearch: function () {
				this.tableCurrentPage = 1;
				this.btnPressType = 1
				this.search();
			},

			clearSearch() {
				this.btnPressType = 2;
				this.searchForm.imei = '';
				this.searchForm.status = '';
				this.searchForm = {
					deviceCode: '',
					alarmType: '',
					level: '',
					alarmRuleName: '',
					data: '',
				}
			},

			getDtuDetail(rowData) {
				return new Promise((resolve, reject) => {
					this.$RequestUtil.get({
						url: '/api/dtu/getDtuDetail',
						type: 'sync',
						params: {
							id: rowData.id
						},
						success: (res) => {
							if (res.code != -1) {
								resolve(res.data);
							} else {
								this.$message({
								type: 'error',
								message: res.message
								});
								reject(res)
							}
						}
					});
				})
			},

			viewAlarm(rowData) {
				this.currentRow = rowData;
				this.viewDialogVisible = true;
			},

			parseDate: function (time) {
				if (time != null) {
					let dateString = commonUtils.timestampToDate(time, false);
					return dateString;
				}
			},
		}
	}
</script>
<style scoped>
	.table_searchbar {
		width: 100%;
		margin-top: 10px;
		margin-bottom: 20px;
	}

	.table_searchbar .title11 {
		color: #606266;
		font-family: NotoSansHans-Regula;
		font-size: 14px;
	}

	.el-row {
		margin-bottom: 20px;

	&
	:last-child {
		margin-bottom: 0;
	}

	}
	.addForm .value {
		display: inline-block;
		width: 280px;
		text-align: center
	}

	.addForm .title {
		width: 70px;
		text-align: right;
		display: inline-block
	}

	.page {
		display: flex;
		justify-content: flex-end;
	}

	.total_page {
		margin-top: 20px;
		margin-right: 26px;
		color: #606266;
		font-size: 14px;
	}
	@media screen and (max-width: 1366px) {
		.y_inputWidth{
		width: 180px!important;
		}
	}
</style>



// WEBPACK FOOTER //
// src/views/alarm/alarmHistory.vue